import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import type { ReactNode } from 'react';

const ADMIN_ENABLED = true;

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

//destructured props must match the interface
function ProtectedRoute({
  children,
  requireAdmin = false
}: ProtectedRouteProps) {

  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!ADMIN_ENABLED) {
    return <Navigate to="/" replace state={{
      message: "Administration is not yet available."
    }} />;
  }
  
  if (!user) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !user.is_admin) {
    // If admin access is required but user is not admin, redirect to home
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute; 